import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { type AxiosResponse } from 'axios';
import { type WellbeingTypes } from 'constants/wellbeing';
import { type Tag, type Wellbeing } from 'types/wellbeing';
import { getUserId } from 'utils/storage';

const API_URL = `${BASE_URL}wellbeing`;

export interface WellbeingServiceTypes {
  getContent: (type: WellbeingTypes) => Promise<AxiosResponse<Wellbeing[]>>;
  getTags: () => Promise<AxiosResponse<Tag[]>>;
}

export const WellbeingService: WellbeingServiceTypes = {
  getContent: (type: WellbeingTypes) => service.get(`${API_URL}/${type}/patients/${getUserId()}`),
  getTags: () => service.get(`${API_URL}/tags`),
};
